module.exports = __webpack_public_path__ + "static/img/2_8_2.14be752a.jpg";